import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "l-main"
}
const _hoisted_2 = { class: "l-error c-card" }
const _hoisted_3 = { class: "l-error__inner-red" }
const _hoisted_4 = { class: "l-error__message l-error__message--red" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "l-error__btn"
}
const _hoisted_8 = { class: "c-buttonWrap4" }
const _hoisted_9 = {
  key: 1,
  class: "c-common-footer-fixed-no-login"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconAlert = _resolveComponent("IconAlert")!
  const _component_ButtonLink = _resolveComponent("ButtonLink")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (!_ctx.ssoFlg)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, [
                _createVNode(_component_IconAlert)
              ]),
              (_ctx.ssoFlg)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _cache[0] || (_cache[0] = [
                    _createTextVNode(" ログイン画面からのアクセスをお願いします。 ", -1),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" ブラウザの「×」(閉じる)ボタンで閉じてください。 ", -1)
                  ])))
                : (_openBlock(), _createElementBlock("p", _hoisted_6, _cache[1] || (_cache[1] = [
                    _createTextVNode(" セッションタイムアウトになりました。 ", -1),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" お手数ですが、再度ログインしてください。 ", -1)
                  ])))
            ]),
            (!_ctx.ssoFlg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_ButtonLink, {
                      tag: "a",
                      href: _ctx.redirectUrl,
                      "style-type": "primary",
                      color: "color2"
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode(" ログイン ", -1)
                      ])),
                      _: 1,
                      __: [2]
                    }, 8, ["href"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("main", _hoisted_9, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "c-common-footer-fixed-no-login__inner" }, [
          _createElementVNode("div", { class: "p-sso-logout" }, [
            _createElementVNode("h3", null, "SSO Access Error"),
            _createElementVNode("p", null, "認証エラーもしくはセッションタイムアウトしました。"),
            _createElementVNode("p", null, " ブラウザの「×」（閉じる）ボタンで閉じてください。再度、エラーとなる場合は担当者様にご確認ください。 ")
          ])
        ], -1)),
        _createVNode(_component_TheFooter)
      ]))
}